import type { ReduxAction } from "ee/constants/ReduxActionConstants";
import { ReduxActionTypes } from "ee/constants/ReduxActionConstants";
import { createReducer } from "utils/ReducerUtils";

export interface ApprovalProcessReducerState {
  processList: Array<{
    id: string;
    label: string;
    value: string;
  }>;
  isLoading: boolean;
  error: string | null;
}

const initialState: ApprovalProcessReducerState = {
  processList: [],
  isLoading: false,
  error: null,
};

const approvalProcessReducer = createReducer(initialState, {
  // 流程列表相关
  [ReduxActionTypes.AF_FETCH_PROCESS_DESIGN_SUCCESS]: (
    state: ApprovalProcessReducerState,
    action: ReduxAction<Array<any>>,
  ) => ({
    ...state,
    processList: action.payload
      ?.filter?.((item) => !!item.enabled)
      ?.map((process) => ({
        id: process.id,
        label: process.name,
        value: process.id,
      })),
    isLoading: false,
    error: null,
  }),
});

export default approvalProcessReducer;
